import { useQuery } from '@tanstack/react-query';
import { getCardsWithFilters, getRares, getUniverses, getVlCardsByFilter } from '../../api/card';
import './HomePage.scss';
import Card from '../../components/card/Card';
import Filter from './Filter';
import { useEffect, useRef, useState } from 'react';
import Pagination from '../../components/pagination/Pagination';
import OpenCard from '../../components/card/OpenCard';
import gsap from 'gsap';
import DialogWindow from '../../components/modalWindow/DialogWindow';

function HomePage() {
    const limit = 12;
    const [filters, setFilters] = useState({universe: null, rare: null, limit: limit, offset: 0});
    const [page, setPage] = useState(1);
    const [isOpenCard, setIsOpenCard] = useState(false);
    const [isRenderingCard, setIsRenderingCard] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const paginationRef = useRef(null);
    const pageRef = useRef(null);

    useEffect(() => {
        setPage(1)
    }, [filters.universe, filters.rare])

    useEffect(() => {
        setFilters(prev => ({...prev, offset: page * limit - limit}))
    }, [page])

    const onClickCard = (card) => {
        setSelectedCard(card)
        setIsOpenCard(true)
    }

    const {data: vlCards, isLoading: vlCardsLoading} = useQuery({
        queryKey: ["vlCardsByFilter", filters.universe, filters.rare],
        queryFn: () => getVlCardsByFilter(filters)
    })

    const {data: universes, isLoading: universesLoading} = useQuery({
        queryKey: ["universes"],
        queryFn: getUniverses
    })

    const {data: rares, isLoading: raresLoading} = useQuery({
        queryKey: ["rares"],
        queryFn: getRares
    })

    const {data: cards, isLoading: filterCardsLoading} = useQuery({
        queryKey: ["filterCards", filters],
        queryFn: () => getCardsWithFilters(filters)
    })

    const isLoading = filterCardsLoading || vlCardsLoading || universesLoading || raresLoading

    useEffect(() => {
        if (!universesLoading && !raresLoading) {
            gsap.to(pageRef.current,
                {opacity: 1, y: 0, scale: 1, duration: .5, ease: "power2.out"}
            )
        }
    }, [universesLoading, raresLoading])

    useEffect(() => {
        if (page !== 1 && paginationRef.current && !isLoading) {
            const timeout = setTimeout(() => {
                paginationRef.current.scrollIntoView({ behavior: "smooth" });
            }, 30);
            return () => clearTimeout(timeout); 
        }
    }, [page, isLoading])

    return (
        <div className="cards-list-wrapper" ref={pageRef}>
            <DialogWindow 
                isOpen={isOpenCard}
                setIsOpen={setIsOpenCard}
                isRendering={isRenderingCard}
                setIsRendering={setIsRenderingCard}
                description="Карта"
                children={selectedCard && <OpenCard card={selectedCard} />}
            />

            {universes && rares && <Filter
                setPage={setPage}
                universes={universes}
                rares={rares}
                filters={filters}
                setFilters={setFilters}
            />}

            {vlCards && <div className="cards-list-block">
                <div className='vl-cards-text'>Количество карт: {vlCards}</div>

                <div className='cards-list'>
                    {!isLoading && cards.map((card) => (<Card key={card.id} card={card} onClick={() => onClickCard(card)} />))}
                </div>

                <Pagination
                    ref={paginationRef}
                    page={page}
                    setPage={setPage}
                    vlCards={vlCards}
                    limit={limit}
                    />
            </div>}

        </div>
    )
}

export default HomePage;